import { useCallback } from "react";
import Papa from "papaparse";
import { Dirary } from "../../types/dirary";
const headers = [
  "日報ID",
  "社員番号",
  "社員名",
  "部署ID",
  "所属工場ID",
  "役職コード",
  "作業開始日",
  "製作工場",
  "工事区分",
  "作業開始時間",
  "作業終了時間",
  "30分休憩",
  "合計作業時間(時間)",
  "合計作業時間(分)",
  "製作番号1",
  "製作番号2",
  "現場名",
  "伝票番号",
  "工程名",
  "工程ID",
  "予定工数",
  "作業時間(時間)",
  "作業時間(分)",
  "コメント",
  // "送信可能",
  // "無効",
];

const useCsvDownloader = () => {
  const downloadCsv = useCallback(
    (diaryList: Array<Dirary>, filename: string) => {
      const data = diaryList.map((diary) => ({
        日報ID: diary.id,
        社員番号: diary.workerId,
        社員名: diary.workerName,
        部署ID: diary.departmentId,
        所属工場ID: diary.affiliationFactoryId,
        役職コード: diary.jobId,
        作業開始日: diary.workingDate,
        製作工場: diary.factoryId,
        工事区分: diary.constructionId,
        作業開始時間: diary.startTime,
        作業終了時間: diary.endTime,
        "休憩有無": diary.isBreak,
        "休憩時間（分）":diary.breakTime,
        "合計作業時間(時間)": diary.totalWorkingTimeByHour,
        "合計作業時間(分)": diary.totalWorkingTimeByMinute,
        製作番号1: diary.productNo,
        製作番号2: diary.productBno,
        現場名: diary.siteName,
        伝票番号: diary.slipNumber,
        工程名: diary.processName,
        工程ID: diary.processId,
        予定工数: diary.estimatedTime,
        "作業時間(時間)": diary.workingTimeByHour,
        "作業時間(分)": diary.workingTimeByMinute,
        コメント: diary.comment,
        // 送信可能: diary.isSendable,
        // 無効: diary.isDisabled,
      }));

      // 現在の日時をYYYYMMDDHHMMSS形式で取得
      const now = new Date();
      //const jstOffset = 9 * 60; // UTC+9のオフセット（分）
      //now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + jstOffset);
      // const timestamp = now.toISOString().replace(/[-:T]/g, "").slice(0, 14);
      const timestamp = formatDateForFilename(now);
      const fullname = `${filename}_${timestamp}.csv`;

      // CSVデータを変換
      const bom = "\uFEFF"; // BOMの追加
      const csv = bom + Papa.unparse({ fields: headers, data });

      // Blobを使ってCSVファイルを作成
      const csvFile = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      // ダウンロード用のリンクを作成
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(csvFile);
      downloadLink.setAttribute("download", fullname);
      // リンクをクリックしてダウンロードを実行
      document.body.appendChild(downloadLink); // DOMにリンクを追加
      downloadLink.click(); // リンクをクリック
      document.body.removeChild(downloadLink); // リンクを削除
    },
    []
  );

  return { downloadCsv };
};

const formatDateForFilename = (date: Date) => {
  if (!date) return "";

  const d = new Date(date);
  const year = d.getFullYear();
  const month = `0${d.getMonth() + 1}`.slice(-2);
  const day = `0${d.getDate()}`.slice(-2);
  const hour = `0${d.getHours()}`.slice(-2);
  const minute = `0${d.getMinutes()}`.slice(-2);
  const second = `0${d.getSeconds()}`.slice(-2);

  return `${year}${month}${day}_${hour}${minute}${second}`;
};

export default useCsvDownloader;
/*
data = [
  [
    { id: 1, name: "aaa", value: 20 },
    { id: 3, name: "b", value: 20 },
    { id: 2, name: "aaa", value: 20 },
  ],
  [
    { id: 1, name: "aaa", value: 20 },
    { id: 3, name: "daa", value: 40 },
    { id: 2, name: "aaa", value: 20 },
  ],
  [
    { id: 1, name: "ff", value: 40 },
    { id: 3, name: "aea", value: 20 },
    { id: 2, name: "aaa", value: 20 },
  ],
];
header = [{ columnId: "ID", isShow: true }];
input =[[{"ID":"11111" },{name:"maeda"}],[{"ID":"12345" },{name:"hayashi"}]]
output =[["11111","maeda"],[12345,"hayashi"]]
*/
